export default __webpack_public_path__ + "static/media/admin.0218b62c.jpg";